import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import classNames from "classnames";
import styles from "../styles/proposition-bets-widget.module.scss";

const PropositionBetsWidgetAsyncComponent = AsyncComponent(async () => import('./proposition-bets-widget' /* webpackChunkName: "proposition-bets-widget" */ ));

export const PropositionBetsWidgetAsync = (props) => {
  return <React.Suspense fallback={<div className={classNames(styles.placeholder)}/>}>
    <PropositionBetsWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
